import React from 'react'
import PropTypes from 'prop-types'
import { Field, ErrorMessage } from 'formik'

import { getFieldState } from 'services/Forms'
import { ButtonGroup } from 'ui'

import { t } from 'translations'

const RadioSimple = ({ options, fieldClass, noLabel, buttonRadios, verticalButtonGroup, ...props }) => {
  const renderRadios = (field, form) => {
    if (buttonRadios) {
      return (
        <ButtonGroup toggle className={`${verticalButtonGroup ? 'w-100' : ''}`} vertical={verticalButtonGroup}>
          {options.map(option => {
            const buttonClassActive = `btn btn-outline-secondary ${option === field.value ? 'active' : ''}`
            const buttonClassDisabled = `btn ${option === field.value ? 'btn-secondary disabled' : 'btn-outline-secondary disabled'}`
            return (
              <label
                className={props.disabled ? buttonClassDisabled : buttonClassActive}
                key={option}
                {...(!props.disabled && { onClick: () => form.setFieldValue(props.name, option) })}
              >
                <input className={`form-check-input`} type="radio" name={props.name} {...field} checked={option === field.value} value={option} />
                {t(`${props.module}.${(props.translation || props.name).toUpperCase()}.OPTIONS.${option}.LABEL`)}
              </label>
            )
          })}
        </ButtonGroup>
      )
    } else {
      return options.map(option => {
        return (
          <div key={option} className="form-check">
            <input
              className={`form-check-input`}
              type="radio"
              name={props.name}
              {...field}
              checked={option === field.value}
              onChange={() => form.setFieldValue(props.name, option)}
              value={option}
              disabled={props.disabled}
            />
            <label className="form-check-label" htmlFor={option.toString()}>
              {t(`${props.module}.${(props.translation || props.name).toUpperCase()}.OPTIONS.${option}.LABEL`)}
            </label>
            <small className="form-text text-muted">
              {t(`${props.module}.${(props.translation || props.name).toUpperCase()}.OPTIONS.${option}.DESCRIPTION`)}
            </small>
          </div>
        )
      })
    }
  }

  return (
    <Field {...props}>
      {({ field, form }) => {
        const fieldState = getFieldState(form, field)
        return (
          <div className={`form-group ${fieldState} ${props.required ? 'required' : ''} ${fieldClass}`}>
            {!noLabel ? (
              <label className={`control-label ${fieldState}`}>{t(`${props.module}.${(props.translation || props.name).toUpperCase()}.LABEL`)}</label>
            ) : null}
            {renderRadios(field, form)}

            <ErrorMessage name={props.name} render={msg => <span className="text-danger"> {t(msg)}</span>} />
          </div>
        )
      }}
    </Field>
  )
}

export default RadioSimple

// Set the proptypes for validation
RadioSimple.propTypes = {
  name: PropTypes.string.isRequired,
  module: PropTypes.string.isRequired,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.bool)]).isRequired
}
